import api from "@/api/api-v2-config";
import MilestonesList from "@/views/projectmanagement/MilestonesList.vue";

//#region Project

export async function getProjectListAxios() {
    return await api.get("projectmanagements/projects?PageNumber=1&PageSize=100000");
}

export async function getProjectByIdAxios(id) {
    return await api.get("projectmanagements/project?ProjectId=" + id);
}


export async function postProjectAxios(item) {
    return await api.post("projectmanagements/project", item);
}

export async function putProjectAxios(item) {
    return await api.put("projectmanagements/project", item);
}

export async function deteteProjectAxios(id) {
    return await api.delete("projectmanagements/project?ProjectId=" + id);
}

//#endregion

//#region Tasks
// export async function getProjectTasksAxios(id, milestoneId) {
//     console.log("🚀 ~ getProjectTasksAxios ~ id:", id)
//     return await api.get(`projectmanagements/tasks?ProjectId=${id}` + (milestoneId == null ? '' : `&MilestonesId=${milestoneId}`));
// }
export async function getProjectTasksAxios(id, milestoneId, pageNumber = 1, pageSize = 10000) {
    console.log("🚀 ~ getProjectTasksAxios ~ id:", id);

    let url = `projectmanagements/tasks?ProjectId=${id}&PageNumber=${pageNumber}&PageSize=${pageSize}`;

    if (milestoneId != null) {
        url += `&MilestonesId=${milestoneId}`;
    }

    return await api.get(url);
}

export async function postProjectTaskAxios(item) {
    return await api.post("projectmanagements/tasks", item);
}

export async function putProjectTaskAxios(item) {
    return await api.put("projectmanagements/tasks", item);
}

export async function deteteProjectTaskAxios(id) {
    return await api.delete("projectmanagements/tasks?TaskId=" + id);
}

export async function updateProjectTaskAxios(item) {
    return await api.put("projectmanagements/updatetaskstatusasync", item);
}

//#endregion

//#region Sub Tasks
export async function getProjectSubTasksAxios(projectId, taskId) {
    return await api.get(`projectmanagements/subtasks?PageNumber=1&PageSize=10000&ProjectId=${projectId}&TaskId=${taskId}`);
}

export async function postProjectSubTaskAxios(item) {
    return await api.post("projectmanagements/subtasks", item);
}

export async function putProjectSubTaskAxios(item) {
    return await api.put("projectmanagements/subtasks", item);
}

export async function deteteProjectSubTaskAxios(id) {
    return await api.delete("projectmanagements/subtasks?SubTaskId=" + id);
}

export async function updateProjectSubTaskAxios(item) {
    return await api.put("projectmanagements/updatesubtaskstatusasync", item);
}

//#endregion

//#region Milestones

export async function getProjectMilestoneAxios(id) {
    return await api.get("projectmanagements/milestones?ProjectId=" + id);
}

export async function postProjectMilestoneAxios(item) {
    return await api.post("projectmanagements/milestones", item);
}

export async function putProjectMilestoneAxios(item) {
    return await api.put("projectmanagements/milestones", item);
}

export async function deteteProjectMilestoneAxios(id) {
    return await api.delete("projectmanagements/milestones?MilestoneId=" + id);
}

//#endregion

export async function getProjectAssigneesAxios() {
    return await api.get("projectmanagements/projectassignees");
}